import { CheckpointType } from "@/components/Procedures/Types/ManualChecklistTypes";

import { Checklist } from "@/model/Checklist/Checklist";
import { ProcedureNodeStep } from "@/model/Procedure/ProcedureNodeStep";

export const calculateIsStepActive = (
	step: ProcedureNodeStep,
	checklist: Checklist | undefined,
) => {
	if (!checklist || !step || step.CheckpointType === CheckpointType.Info)
		return false;

	const allSteps = checklist.Steps;
	if (!allSteps.some((x) => x.Id == step.Id)) {
		return false;
	}

	const stepIndex = allSteps.findIndex((x) => x.Id === step.Id);

	if (stepIndex === -1) {
		return false;
	}

	if (stepIndex === 0) {
		return true;
	}

	for (let i = stepIndex - 1; i >= 0; i--) {
		if (
			allSteps[i].IsSkipped ||
			allSteps[i].IsOverridden ||
			allSteps[i].CheckpointType === CheckpointType.Info
		) {
			if (i == 0) {
				return true;
			}

			continue;
		}

		return allSteps[i].Status === 1;
	}

	return true;
};
